<template>
    <span></span>
</template>

<script>
import axios from 'axios'

export default {
    props: {
        /**
         * Interval in minutes
         */
        interval: {
            required: true,
            type: Number
        }
    },

    created () {
        this.scheduleHeartbeat()
    },

    methods: {
        beat () {
            axios.get('/heartbeat')
                .then(() => {
                    this.scheduleHeartbeat()
                })
                .catch(() => {
                    console.log('Error with heartbeat!')
                })
        },

        scheduleHeartbeat () {
            setTimeout(this.beat, this.interval * 60 * 1000)
        }
    }
}

</script>
